import { EnumTableConfig } from '@/components/table/_fieldDefinitions/enum/EnumTableConfig.ts';
import {
  plainEnumConfig,
  toneEnumConfig,
} from '@/components/table/_fieldDefinitions/enum/enumToneConfig.ts';
import { InvitationStatus } from '@/features/dashboard/invitations/types/InvitationStatus.ts';
import Role from '@/features/auth/login/types/Role.ts';
import { ROLE_LABELS } from '@/features/auth/login/types/Role.utils.ts';

export const invitationStatusTableConfig: EnumTableConfig = {
  [InvitationStatus.PENDING]: toneEnumConfig('Oczekujące', 'warning'),
  [InvitationStatus.ACCEPTED]: toneEnumConfig('Zaakceptowane', 'success'),
  [InvitationStatus.CANCELLED]: toneEnumConfig('Anulowane', 'caution'),
  [InvitationStatus.EXPIRED]: toneEnumConfig('Wygasłe', 'error'),
};

export const roleTableConfig: EnumTableConfig = {
  [Role.Owner]: plainEnumConfig(ROLE_LABELS[Role.Owner]),
  [Role.User]: plainEnumConfig(ROLE_LABELS[Role.User]),
};
